var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shape-choose"},[_c('ShapeRemoteLoader'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col  d-none"},[_c('ShapeEditor')],1),_c('div',{staticClass:"col"},[_c('ShapeUpload')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }